<template>
  <div class="max-w-4xl mx-auto my-10 p-6 md:p-10 bg-white shadow-xl shadow-slate-200/40 rounded-2xl border border-slate-100 transition-all duration-300">
    
    <div class="text-center space-y-3 mb-10">
      <div class="inline-flex items-center justify-center p-3 bg-indigo-50 rounded-xl text-indigo-600 mb-3 border border-indigo-100 shadow-sm">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path></svg>
      </div>
      <h1 class="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">Universal Format Decoder</h1>
      <p class="text-slate-500 text-base max-w-2xl mx-auto leading-relaxed">
        The all-in-one developer utility hub. Seamlessly encode, decode, and format complex strings including URLs, Base64 imagery, JSON payloads, HTML entities, and JWTs.
      </p>
    </div>

    <div class="my-8 relative z-10">
      <EncodeDecode />
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
      
      <div class="bg-blue-50 border border-blue-100 rounded-xl p-6 h-full shadow-inner">
        <h3 class="text-blue-900 font-bold flex items-center gap-2 mb-5">
          <span>🚀</span> Quick Start Guide
        </h3>
        <ul class="space-y-4 text-sm text-blue-800">
          <li class="flex items-start gap-3">
            <span class="bg-blue-200 text-blue-900 rounded-full w-5 h-5 flex items-center justify-center text-[10px] font-bold shrink-0 mt-0.5">1</span>
            <span>Paste your raw data, URL, or code string into the editor.</span>
          </li>
          <li class="flex items-start gap-3">
            <span class="bg-blue-200 text-blue-900 rounded-full w-5 h-5 flex items-center justify-center text-[10px] font-bold shrink-0 mt-0.5">2</span>
            <span>Select the correct processing format from the dropdown menu.</span>
          </li>
          <li class="flex items-start gap-3">
            <span class="bg-blue-200 text-blue-900 rounded-full w-5 h-5 flex items-center justify-center text-[10px] font-bold shrink-0 mt-0.5">3</span>
            <span>Click <strong>Decode</strong> to unpack/format data or <strong>Encode</strong> to compress/obfuscate it.</span>
          </li>
        </ul>
      </div>

      <div class="bg-slate-50 border border-slate-200 rounded-xl p-6 h-full shadow-inner">
        <h3 class="text-slate-800 font-bold flex items-center gap-2 mb-5">
          <span>⚙️</span> Capabilities
        </h3>
        <div class="space-y-4 text-sm">
          
          <div class="bg-white p-3 rounded-lg border border-slate-100 shadow-sm">
            <span class="inline-block px-2 py-1 bg-slate-100 text-slate-700 text-[9px] uppercase tracking-wider font-bold rounded mb-1">URL / UTF-8</span>
            <p class="text-slate-500 font-mono text-xs truncate">Converts spaces & special chars (e.g. %20)</p>
          </div>

          <div class="bg-white p-3 rounded-lg border border-slate-100 shadow-sm">
            <span class="inline-block px-2 py-1 bg-slate-100 text-slate-700 text-[9px] uppercase tracking-wider font-bold rounded mb-1">JSON Ops</span>
            <p class="text-slate-500 font-mono text-xs truncate">Prettifies nested objects or minifies strings</p>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div class="bg-white p-3 rounded-lg border border-slate-100 shadow-sm">
              <span class="inline-block px-2 py-1 bg-slate-100 text-slate-700 text-[9px] uppercase tracking-wider font-bold rounded mb-1">JWT</span>
              <p class="text-slate-500 font-mono text-xs">Extracts payloads</p>
            </div>
            <div class="bg-white p-3 rounded-lg border border-slate-100 shadow-sm">
              <span class="inline-block px-2 py-1 bg-slate-100 text-slate-700 text-[9px] uppercase tracking-wider font-bold rounded mb-1">HTML</span>
              <p class="text-slate-500 font-mono text-xs">Parses code tags</p>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import EncodeDecode from './EncodeDecode.vue';

export default {
  name: 'Main',
  components: {
    EncodeDecode
  }
}
</script>